import { PaidAccountModel } from 'app/gamma/src/types/models';
import { PaidAccountResponse } from 'app/gamma/src/types/responses';

import genericNormalizer from './generic';

export const normalizePaidAccount = genericNormalizer<
  PaidAccountResponse,
  PaidAccountModel
>(({ from }) => ({
  standing: from('standing'),
}));
